export default __webpack_public_path__ + "static/media/img_noData_line.b59ff56f.svg";